import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { PRODUCT_REVEAL, FEATURES } from '../constants/content';
export function WhatYouGet() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-280">
      <div className="mx-auto max-w-6xl px-4" data-id="element-281">
        {/* Product reveal */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mx-auto mb-14 max-w-3xl text-center" data-id="element-282">
          <span className="mb-2 block font-display text-xl font-500 uppercase tracking-widest text-crimson" data-id="element-283">
            {PRODUCT_REVEAL.kicker}
          </span>
          <h2 className="font-display text-4xl font-700 leading-none text-ink sm:text-6xl" data-id="element-284">
            {PRODUCT_REVEAL.name}
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-display text-lg font-500 text-gold-dark" data-id="element-285">
            {PRODUCT_REVEAL.tagline}
          </p>
          <p className="mt-6 text-lg leading-relaxed text-gray-800" data-id="element-286">
            {PRODUCT_REVEAL.promise}
          </p>
          <p className="mt-3 text-base leading-relaxed text-gray-600" data-id="element-287">
            {PRODUCT_REVEAL.promise2}
          </p>
        </motion.div>

        <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-288">
          <p className="font-display text-2xl font-600 text-ink" data-id="element-289">
            ¿Qué hace que un sistema para poner una pollería sea realmente
            bueno?
          </p>
          <p className="mt-3 text-base leading-relaxed text-gray-700" data-id="element-290">
            Simple: tiene que ser lo suficientemente detallado como para no
            dejarte adivinando nada, pero lo suficientemente simple como para
            que lo entienda alguien que nunca puso un negocio en su vida. Y
            tiene que cubrirte de punta a punta: desde el trámite hasta la caja
            registradora.
          </p>
          <p className="mt-3 text-base font-600 text-crimson" data-id="element-291">
            Mirá las características y entendé por qué este sistema es 10 veces
            mejor que cualquier «consejo» gratis que hayas visto:
          </p>
        </div>

        {/* Alternating feature rows */}
        <div className="space-y-12" data-id="element-292">
          {FEATURES.map((f, i) => {
          const reversed = i % 2 === 1;
          return <motion.article key={f.tag} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5
          }} className={`flex flex-col items-center gap-6 lg:gap-10 ${reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'}`} data-id="element-293">
                <div className="w-full lg:w-1/2" data-id="element-294">
                  <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5" data-id="element-295">
                    <img src={f.img} alt={f.title} width={900} height={675} loading="lazy" decoding="async" onError={e => {
                  const img = e.currentTarget;
                  // Fallback to a verified poultry photo so no broken image shows.
                  if (!img.dataset.fallback) {
                    img.dataset.fallback = 'true';
                    img.src = 'https://images.unsplash.com/photo-1604503468506-a8da13d82791?auto=format&fit=crop&w=800&q=70&fm=webp';
                  }
                }} className="aspect-[4/3] w-full object-cover" data-id="element-296" />
                  </div>
                </div>
                <div className="w-full lg:w-1/2" data-id="element-297">
                  <span className="mb-2 inline-block rounded-full bg-crimson/10 px-3 py-1 text-sm font-700 uppercase tracking-wide text-crimson" data-id="element-298">
                    {f.tag}
                  </span>
                  <h3 className="mb-3 font-display text-2xl font-600 text-ink sm:text-3xl" data-id="element-299">
                    {f.title}
                  </h3>
                  <p className="mb-4 text-base leading-relaxed text-gray-800" data-id="element-300">
                    {f.body}
                  </p>
                  <p className="flex items-start gap-2 rounded-lg bg-green-50 p-4 text-base leading-relaxed text-gray-700 ring-1 ring-green-100" data-id="element-301">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green-600" aria-hidden="true" data-id="element-302" />
                    <span data-id="element-303">{f.note}</span>
                  </p>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}